import { Field } from 'react-final-form';
import Message from '../../Forms/message';
import { FormWrapper, FormSection, SectionLabel, Content } from '../Wizard/common';
import { DRONE_VALUES } from '../configValues';
import Input from '../../Forms/input';
import Select from '../../Forms/select';
import TextArea from '../../Forms/textarea';
import { InputWrapper } from '../../Forms/common';

function UploadingMultimedia({ uploadType }) {

  return (
    <FormWrapper>
      <FormSection>
        <SectionLabel>Project Information</SectionLabel>
        <Content>
          <Field name="projectName">
            {({ input, meta }) => (
              <InputWrapper>
                <label>Project name</label>
                <Input type="text" placeholder="Enter project name" {...input} {...meta} />
                {
                  meta.touched && meta.error && (
                    <Message isError>{meta.error}</Message>
                  )
                }
              </InputWrapper>
            )}
          </Field>

          <Field name="comment">
            {({ input, meta }) => (
              <InputWrapper>
                <label>Comments</label>
                <TextArea
                  placeholder="Enter comments"
                  rows="4"
                  {...input}
                  {...meta} />
              </InputWrapper>
            )}
          </Field>
        </Content>
      </FormSection>
      <FormSection>
        <SectionLabel>Flight Information</SectionLabel>
        <Content>
          <Field name="flightName">
            {({ input, meta }) => (
              <InputWrapper>
                <label>Flight name</label>
                <Input type="text" placeholder="Enter flight name" {...input} {...meta} />
                {
                  meta.touched && meta.error && (
                    <Message isError>{meta.error}</Message>
                  )
                }
              </InputWrapper>
            )}
          </Field>

          <Field name="droneType">
            {({ input, meta }) => (
              <InputWrapper>
                <label>Drone type</label>
                <Select
                  id="droneType"
                  placeholder="Select drone"
                  options={DRONE_VALUES}
                  getOptionLabel={(options) => options['drone']}
                  getOptionValue={(options) => options['id']}
                  {...input}
                  {...meta}
                  onChange={value => {
                    input.onChange(value);
                  }}
                />
              </InputWrapper>
            )}
          </Field>
          <Field name="note">
            {({ input, meta }) => (
              <InputWrapper>
                <label className="se-label">Notes</label>
                <TextArea
                  placeholder="Enter notes"
                  rows="4"
                  {...input}
                  {...meta} />
              </InputWrapper>
            )}
          </Field>

          {
            uploadType === 'video' && (
              <Field name="realEstate">
                {({ input, meta }) => (
                  <InputWrapper>
                    <label>Real Estate</label>
                    <Input type="text" placeholder="56442001470001" {...input} {...meta} />
                    {
                      meta.touched && meta.error && (
                        <Message isError>{meta.error}</Message>
                      )
                    }
                  </InputWrapper>
                )}
              </Field>
            )}

          </Content>
      </FormSection>
    </FormWrapper>
  )
};

export default UploadingMultimedia;